import { Cookies } from "react-cookie-consent";

export const setCookiePreferences = (values: string[]) => {
  localStorage.setItem('is_google_analytics_accepted', values.includes('google-analytics') ? 'true' : 'false');

  if (!values.includes('google-analytics')) {
    Cookies.remove('_ga');
    Cookies.remove('_ga_SG3YWTHTHW');
  }
}